import { Case } from '../api/getCases';
import { LOCALES } from '../constants/common';
import { Locale } from '../types';

export enum CASES_TAGS {
  API_AND_SDK = 'API и SDK',
  DB = 'Базы данных',
  MAPS_API = 'API карт',
  CATALOG_API = 'API Поиск',
  NAVIGATION_API = 'API навигации',
  MOBILE_SDK = 'Mobile SDK',
  VECTOR_MAPS = 'Векторные карты',
  TWO_GIS_PRO = '2ГИС Про',
  ON_PREMISE = 'On-Premise',
  PRINT = 'Печатная продукция',
  ROUTE_PLANNER_API = 'Route Planner API',
}

export enum CASES_INDUSTRIES {
  BUSINESS = 'Бизнес',
  GOVERNMENT = 'Госсектор',
}

/**
 * Кейсы, доступные только в РУ локали
 */
export const RU_ONLY_CASES_URLS = [
  '/cases/sme_government',
  '/cases/megapteka_api',
];

export const filterCasesByLocale = (cases: Case[], locale: Locale) => {
  if (locale === LOCALES.ru) {
    return cases;
  }

  return cases.filter(
    (el) => !RU_ONLY_CASES_URLS.some((url) => el.url?.includes(url)),
  );
};

export const formatCasesItems = (cases: Case[]) => {
  return cases.map((el) => ({
    id: el.id,
    img: el.img,
    chips: el.industries,
    tags: el.products,
    alt: el.title,
    label: el.title,
    urlArticle: el.url,
    url: el.url,
    description: el.description,
    imgHeight: el.imgHeight,
    title: el.title,
    products: el.products,
    industries: el.industries,
  }));
};

export const translateCasesItems = (
  cases: Case[],
  translations: Record<string, string>,
) => {
  return cases.map((el) => ({
    ...el,
    title: translations[el.title] ?? el.title,
    description: translations[el.description] ?? el.description,
  }));
};
